var _rect, _rect2, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKleiFreshbalance = function SvgKleiFreshbalance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 49.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 49.5,
    stroke: "#E2DFDF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.9453,
    cy: 40.873,
    r: 15.9023,
    fill: "#D0D5C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4772 45.7113L53.7077 45.2686C52.8941 45.0655 52.3261 44.3383 52.3261 43.4991V41.2666C52.3261 40.7143 51.8784 40.2666 51.3261 40.2666H35.084C34.5317 40.2666 34.084 40.7143 34.084 41.2666V43.4991C34.084 44.3383 33.516 45.0655 32.7024 45.2686L30.9329 45.7113C28.4921 46.3218 26.7871 48.5048 26.7871 51.021V53.3066C26.7871 53.5718 26.8925 53.8262 27.08 54.0137C27.0874 54.0211 27.0949 54.0285 27.1023 54.036C27.2898 54.2235 27.5442 54.3289 27.8094 54.3289H58.6007C58.8659 54.3289 59.1203 54.2235 59.3078 54.036L59.3301 54.0137C59.5176 53.8262 59.623 53.5718 59.623 53.3066V51.021C59.623 48.5048 57.918 46.3218 55.4772 45.7113Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7871 53.6436V75.6558C26.7871 78.6782 29.2373 81.1284 32.2598 81.1284H54.1503C57.1728 81.1284 59.623 78.6782 59.623 75.6558V53.6436H26.7871Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3271 40.2666H34.085C32.0732 40.2666 30.4365 38.675 30.4365 36.7188V22.4092C30.4365 20.4529 32.0732 18.8613 34.085 18.8613H52.3271C54.3388 18.8613 55.9755 20.4529 55.9755 22.4092V36.7188C55.9755 38.675 54.3388 40.2666 52.3271 40.2666Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0569 81.1302C53.2768 81.1302 47.6784 80.7703 43.6834 76.5187C39.0016 71.5361 39.6228 64.3875 39.6517 64.0857C39.7346 63.2153 40.4234 62.526 41.2939 62.4427C41.5851 62.4148 48.4789 61.8181 53.208 66.8511C57.8801 71.8233 57.3388 79.1358 57.3133 79.4447C57.2333 80.4201 56.5604 81.1302 55.0569 81.1302Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4223 81.1186C54.5024 81.0689 53.7639 80.341 53.7008 79.422C53.6762 79.0643 53.1623 70.5924 58.6529 64.7592C64.1988 58.8673 72.1745 59.4487 72.5115 59.4758C73.4017 59.5489 74.1081 60.2556 74.1807 61.1457C74.2091 61.4958 74.8162 69.787 69.3161 75.6304C65.6139 79.5637 59.7922 81.348 55.4223 81.1186Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
};
export default SvgKleiFreshbalance;